const BASE_PATH = 'APP_SECURITY_INFO';

export const SET_SECURITY_INFO_DATA = `${BASE_PATH}/SET_SECURITY_INFO_DATA`;
export const VALIDATE_SECURITY_INFO_DATA = `${BASE_PATH}/VALIDATE_SECURITY_INFO_DATA`;
export const CLEAR_INFO_DATA = `${BASE_PATH}/CLEAR_INFO_DATA`;

export const setSecurityInfoData = data => ({
    type: SET_SECURITY_INFO_DATA,
    data
});

export const validateSecurityInfoData = () => ({
    type: VALIDATE_SECURITY_INFO_DATA,
});

export const clearSecurityInfoData = () => ({
    type: CLEAR_INFO_DATA,
});

const initialState = {
    password: "",
    passwordError: '',

    validate: false,
    isValid: false
}

export default function reducer(state = { ...initialState }, action) {
    switch (action.type) {
        case SET_SECURITY_INFO_DATA:
            let newState = { ...state };
            action.data.forEach(data => {
                newState[data.key] = Array.isArray(data.value) ? [...data.value] : data.value;
            });
            return newState;

        case VALIDATE_SECURITY_INFO_DATA:
            return { ...state, validate: true }
        case CLEAR_INFO_DATA:
            return { ...initialState }
    }

    return state;
}